import { LsAction } from '@/components/ls-action/LsAction';
import { LsLineItem } from '@/components/ls-line-item/LsLineItem';
import { LsOverlay } from '@/components/ls-overlay/LsOverlay';
import { LsPanel } from '@/components/ls-panel/LsPanel';
import { useCartStore } from '@/features/cart/cart.store';
import { COPY } from '@/shared/content/copy';
import { formatRub } from '@/shared/lib/money';
import { icon } from '@/shared/content/icons';
import styles from './ls-cart-drawer.module.scss';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onCheckout: () => void;
  /** Вернуться к выбору изделий. Пусто — кнопки не будет. */
  onBackToCatalog?: () => void;
}

export function LsCartDrawer({ isOpen, onClose, onCheckout, onBackToCatalog }: Props) {
  const items = useCartStore((s) => s.items);
  const total = useCartStore((s) => s.total());
  const setQty = useCartStore((s) => s.setQty);
  const remove = useCartStore((s) => s.remove);
  const clear = useCartStore((s) => s.clear);

  if (!isOpen) return null;

  return (
    <LsOverlay align="end" label={COPY.cart.title} onClose={onClose}>
      <LsPanel
        tone="drawer"
        title={COPY.cart.title}
        onClose={onClose}
        footer={
          <>
            {/*
              Возврат к каталогу — выход из корзины вперёд, а не назад.
              Без него человек с пустой корзиной упирается в тупик:
              закрыть окно и вспомнить, где была витрина, — не путь.
            */}
            {onBackToCatalog && (
              <button
                className={styles['ls-cart-drawer__back']}
                type="button"
                onClick={onBackToCatalog}
              >
                Вернуться к каталогу
              </button>
            )}

            {items.length > 0 && (
              <button
                className={styles['ls-cart-drawer__clear']}
                type="button"
                onClick={clear}
              >
                {COPY.cart.clear}
              </button>
            )}

            <div className={styles['ls-cart-drawer__total']}>
              <span>{COPY.cart.total}</span>
              <span>{formatRub(total)}</span>
            </div>

            <div className={styles['ls-cart-drawer__action']}>
              <LsAction
                label={COPY.cart.checkout}
                disabled={items.length === 0}
                onClick={onCheckout}
              />
            </div>
          </>
        }
      >
        {items.length === 0 ? (
          <div className={styles['ls-cart-drawer__empty']}>
            <img className={styles['ls-cart-drawer__empty-icon']} src={icon('cart')} alt="" />
            <p className={styles['ls-cart-drawer__empty-text']}>{COPY.cart.empty}</p>
          </div>
        ) : (
          <ul className={styles['ls-cart-drawer__items']}>
            {items.map((item) => (
              <LsLineItem
                key={item.id}
                item={item}
                onQtyChange={(qty) => setQty(item.id, qty)}
                onRemove={() => remove(item.id)}
              />
            ))}
          </ul>
        )}
      </LsPanel>
    </LsOverlay>
  );
}
